import { action, observable } from 'mobx';

// share dependencies
import  ColorDialogUtils from 'share/components/controls/ColorDialog/Izenda.ColorDialogUtils';

// data imports
import { metricProperties, CUSTOM_URL } from 'logic/data/Izenda.ReportPartKPIConstants';

/**
 * @class MetricTileProperties
 * @description contains property values for KPI Text tiles
 */
export default class MetricTileProperties {
    @observable border = {
        ...metricProperties.border
    };

    @observable fontFormat = {
        ...metricProperties.font
    };

    @observable fontStyle = {
        ...metricProperties.fontStyle
    };

    @observable color = {
        ...metricProperties.color
    };

    @observable customURL = { option: CUSTOM_URL.DEFAULT_VALUE, url: '' }

    constructor(metricProperties) {
        if (metricProperties){
            this.color = metricProperties.color;
            this.fontFormat = metricProperties.fontFormat;
            this.fontStyle = metricProperties.fontStyle;
            this.customURL = metricProperties.customURL;
            this.border = metricProperties.border;
        }
    }

    /**
     * @method updateProperties
     * @description reset property values with new values
     * @param {object} newProps changed properties
     */
    @action
    updateProperties(newProps) {
        Object.keys(newProps).forEach(key => this[key] = newProps[key]);
    }

    /**
     * @method getStyle
     * @description create React style object based off of properties
     */
    getStyle() {
        const {
            color,
            fontFormat,
            fontStyle
        } = this;

        return {
            backgroundColor: ColorDialogUtils.convertHexToRGBA(color.backgroundColor,color.alpha),
            color: color.textColor,
            fontFamily: fontFormat.fontFamily,
            fontSize: fontFormat.fontSize,
            fontWeight: fontStyle.fontBold ? 'bold' : 'normal',
            fontStyle: fontStyle.fontItalic ? 'italic' : 'normal',
            textDecoration: fontStyle.fontUnderline ? 'underline' : 'none',
            ...this.getBorderStyle()
        };
    }

    /**
     * @method getBorderStyle
     * @description create React style object for border styles
     */
    getBorderStyle() {
        const {
            top,
            left,
            bottom,
            right
        } = this.border;

        return {
            borderTopStyle: top.dashStyle,
            borderTopWidth: `${top.thinkness}px`,
            borderTopColor: top.color,
            borderRightStyle: right.dashStyle,
            borderRightWidth: `${right.thinkness}px`,
            borderRightColor: right.color,
            borderBottomStyle: bottom.dashStyle,
            borderBottomWidth: `${bottom.thinkness}px`,
            borderBottomColor: bottom.color,
            borderLeftStyle: left.dashStyle,
            borderLeftWidth: `${left.thinkness}px`,
            borderLeftColor: left.color
        };
    }
}



// WEBPACK FOOTER //
// ./ui/logic/models/ReportPartKPIModels/Izenda.MetricTileProperties.js